'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { merge } from 'rxjs/observable/merge';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { FETCHED_LIST_REGISTRATIONS } from '../actions/ActionTypes';
import { receiveListRegistrations, requestedListRegistrationsFailed } from '../actions/ListRegistrationsActions';
export default ((action$, _, {
  ListRegistrationsClient
}) => action$.ofType(FETCHED_LIST_REGISTRATIONS).pipe(mergeMap(({
  payload: {
    listIds
  }
}) => merge(ListRegistrationsClient.fetchListRegistrations(listIds).pipe(map(receiveListRegistrations), catchError(error => of(requestedListRegistrationsFailed(error))))))));